export const DIRECTUS_URL = process.env.DIRECTUS_URL ?? "https://directus.ftd.io";
export const DIRECTUS_ACCESS_TOKEN = process.env.NEXT_PUBLIC_DIRECTUS_ACCESS_TOKEN;
export const UPTIME_KUMA_API = process.env.UPTIME_KUMA_API ?? "https://status.ftd.io";
export const FTD = "Free Thinking Design";
export const CURRENCY = "£";
export const URL = process.env.NEXT_PUBLIC_URL ?? "http://localhost:3000";
